import {QuestionSetLabel} from "./question-set-label";
import {Question} from "./question";
import {Utility} from "./utility";
import {Scale} from "./scale";
import {DisplayCondition} from "./display-condition";
export class QuestionSet
{
	private _id:string;
	private _title:string;
	private _questions:Question[];
	private _labels:QuestionSetLabel[];
	private _answer_start_value:number;
	private _display_order:number;
	private _display_type:string;
	private _instructions:string;
	private _display_conditions:DisplayCondition[];
	
	constructor() {
		this.id = null;
		this.title = "";
		this.display_order = 0;
		this.questions = [];
		this.labels = [];
		this.answer_start_value = 1;
		// options are LikertGrid, SingleSelectDropDown
		this.display_type = "MultipleChoiceGrid";
		this.display_conditions = [];
	}

	public getQuestionById(id:string) {
		let q = this.questions.find(q => q.id == id);
		return q;
	}

	public get display_conditions () : DisplayCondition[] {
		return this._display_conditions;
	}

	public set display_conditions(v : DisplayCondition[]) {
		this._display_conditions = v;
	}
	
	public get display_type() : string {
		return this._display_type;
	}

	public set display_type(v : string) {
		this._display_type = v;
	}
	
	public get id() : string {
		return this._id;
	}
	
	public set id(v : string) {
		this._id = v;
	}
	
	public get display_order() : number {
		return this._display_order;
	}
	
	public set display_order(v:number) {
		this._display_order = v;
	}
	
	public get answer_start_value() : number {
		return this._answer_start_value;
	}
	
	public set answer_start_value(v:number) {
		this._answer_start_value = v;
	}
	
	public get title() : string {
		return this._title;
	}
	
	public set title(v : string) {
		this._title = v;
	}
	
	public get questions() : Question[] {
		return this._questions;
	}
	
	public set questions(v : Question[]) {
		this._questions = v;
	}
	
	
	public get labels() : QuestionSetLabel[] {
		return this._labels;
	}
	
	public set labels(v : QuestionSetLabel[]) {
		this._labels = v;
	}

	public get instructions() : string {
		return this._instructions;
	}

	public set instructions(v:string) {
		this._instructions = v;
	}
	
	addQuestion(question:Question) {
		this.questions.push(question);
	}
	
	removeQuestion(question:Question) {
		let index = this.questions.indexOf(question);
		if (index >= 0) {
			this.questions.splice(index, 1);
		}
	}
	
	addLabel(label:QuestionSetLabel) {
		this.labels.push(label);
	}
	removeLabel(label:QuestionSetLabel) {
		let index = this.labels.indexOf(label);
		if (index >= 0) {
			this.labels.splice(index, 1);
		}
	}
	
	shiftLabelUp(label:QuestionSetLabel) {
		Utility.shiftCollectionUp(this.labels, label);
	}
	
	shiftLabelDown(label:QuestionSetLabel) {
		Utility.shiftCollectionDown(this.labels, label);	
	}
	
	shiftQuestionUp(question:Question) {
		Utility.shiftCollectionUp(this.questions, question);
	}
	
	shiftQuestionDown(question:Question) {
		Utility.shiftCollectionDown(this.questions, question);
	}
	
	removeScale(scale:Scale) {
		// get all of the scales and set them to be null
		// for those questions.
		this.questions.filter(q => q.assessment_scale.id == scale.id)
			.forEach(q => q.assessment_scale = null);
	}

	getDisplayConditions() : DisplayCondition[] {
		return this._display_conditions;
	}

	shouldDisplay(question_sets:QuestionSet[]) {
		// cycle through any conditions based upon the question_sets and say whether the current question_set 
		// should display.
		return true;
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question-set.ts